function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouteStart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15,0C6.73,0,0,6.73,0,15s6.73,15,15,15,15-6.73,15-15S23.27,0,15,0Zm0,28c-7.17,0-13-5.83-13-13S7.83,2,15,2s13,5.83,13,13-5.83,13-13,13Z",
    style: {
      fill: "#007bfe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9,18.3h-5.85l-1.12,2.7h-2.99l5.62-12.6h2.88l5.63,12.6h-3.06l-1.12-2.7Zm-.92-2.21l-2-4.82-2,4.82h4Z",
    style: {
      fill: "#007bfe",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouteStart);
export default __webpack_public_path__ + "static/media/icon-route-start.77b41b969290a157cde22434cea1a4c5.svg";
export { ForwardRef as ReactComponent };